// Polyfills
import 'es6-promise/auto'
import 'babel-polyfill'

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VeeValidate from 'vee-validate'
import App from './App'
import store from './store'
import router from './router'
import VuesticPlugin from 'vuestic-theme/vuestic-plugin'
import './i18n'
import YmapPlugin from 'vue-yandex-maps'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import 'firebase/storage'
import vuefire from 'vuefire'
import { extend } from '@firebase/util'


Vue.use(VuesticPlugin)
Vue.use(YmapPlugin)
Vue.use(firebase)
Vue.use(vuefire)

// NOTE: workaround for VeeValidate + vuetable-2
Vue.use(VeeValidate, {fieldsBagName: 'formFields'})


// STSC Project Config
let configFirebase = {
  'adminBoard': {
    apiKey: 'AIzaSyC_lKcTuPZXJfKFbw5Tp4XuM-4mjYllsWw',
    authDomain: 'stscadminboard.firebaseapp.com',
    databaseURL: 'https://stscadminboard.firebaseio.com',
    projectId: 'stscadminboard',
    storageBucket: 'stscadminboard.appspot.com',
    messagingSenderId: '199060262470'
  }
}
let dashboardApp = firebase.initializeApp(configFirebase.adminBoard)
let dbDashboardApp = dashboardApp.database()

let mediaHandler = () => {
  if (window.matchMedia(store.getters.config.windowMatchSizeLg).matches) {
    store.dispatch('toggleSidebar', true)
  } else {
    store.dispatch('toggleSidebar', false)
  }
}

router.beforeEach((to, from, next) => {
  store.commit('setLoading', true)
  if (to.matched.some(record => record.meta.requiresAuth) && to.path !== '/auth/login') {
    firebase.auth().onAuthStateChanged((user) => {
      if (user !== null && user !== undefined) {
        next()
      } else {
        next({
          path: '/auth/login',
          query: { redirect: to.fullPath }
        })
      }
    })
  } else {
    next()
  }
})

router.afterEach((to, from) => {
  mediaHandler()
  store.commit('setLoading', false)
})

/* eslint-disable no-new */

/* Main Mixin config */
Vue.mixin({
  data () {
    return {
      firebaseApp: firebase,
      firebaseAuth: firebase.auth(),
      icon: {
        success: 'fa-check-circle',
        error: 'fa-exclamation-circle',
        info: 'fa-info-circle'
      },
      toast: {
        text: 'This toast is awesome!',
        type: 'info',
        icon: 'fa-star-o',
        duration: 4000,
        position: 'top-center',
        isFullWidth: false
      }
    }
  },
  methods: {
    signOut () {
      try {
        this.firebaseAuth.signOut().then(() => {
          this.$router.push('/')
        }).catch((err) => {
          if (this.isNotNullorUndefined(err)) {
            this.launchToast(err.message, 'error')
          }
        })
      } catch (err) {
        if (this.isNotNullorUndefined(err)) {
          this.launchToast(err.message, 'error')
        }
      }
    },
    clear (field) {
      this[field] = ''
    },
    getMaxArray (array) {
      return Math.max.apply(Math, array)
    },
    getMinArray (array) {
      return Math.min.apply(Math, array)
    },
    arrayHasElements (array) {
      try {
        return array.length > 0
      } catch (e) {
        return false
      }
    },
    whichQuestionType (t) {
      let choiceTypeArray = ['Multiple Choice', 'Picture Choice', 'Single Choice']
      let textTypeArray = ['Short Text', 'Date', 'Email']
      let scaleTypeArray = ['Opinion Scale', 'Rating']

      if (choiceTypeArray.indexOf(t) > -1) return 'choice'
      else if (textTypeArray.indexOf(t) > -1) return 'text'
      else if (scaleTypeArray.indexOf(t) > -1) return 'scale'
      else return 'yesno'
    },
    isNotNullorUndefined (item) {
      return item !== null && item !== undefined
    },
    isFormFieldValid (field) {
      let isValid = false
      if (this.formFields[field]) {
        isValid = this.formFields[field].validated && this.formFields[field].valid
      }
      return isValid
    },
    validateFormField (fieldName) {
      this.$validator.validate(fieldName, this[fieldName])
    },
    foundDulicateInArray (a) {
      for (var i = 0; i <= a.length; i++) {
        for (var j = i; j <= a.length; j++) {
          if (i !== j && a[i] === a[j]) {
            return true
          }
        }
      }
      return false
    },
    launchToast (message, type, icon, duration, position) {
      let m = message || this.toast.text
      let t = type || this.toast.type
      let i = this.icon[t] || this.toast.icon
      this.showToast(m, {
        type: t,
        icon: i,
        duration: duration || this.toast.duration,
        position: position || this.toast.position,
        fullWidth: this.toast.isFullWidth
      })
    },
    capitalizeFirstLetter (string) {
      return string.charAt(0).toUpperCase() + string.slice(1)
    },
    routeQuery () {
      return this.$route.query
    },
    getCurrentUser () {
      return firebase.auth().currentUser
    },
    getTimestamp () {
      return (new Date()).getTime()
    },
    getNewDateWTime () {
      let a = new Date()
      let year = a.getFullYear()
      let month = ('0' + (a.getMonth() + 1)).slice(-2)
      let date = ('0' + a.getDate()).slice(-2)
      let hour = ('0' + a.getHours()).slice(-2)
      let min = ('0' + a.getMinutes()).slice(-2)
      let sec = ('0' + a.getSeconds()).slice(-2)

      return date + '-' + month + '-' + year + '@' + hour + ':' + min + ':' + sec
    },
    getLog (action, target, id, section, success, errMessage) {
      return {
        'action': action || 'add',
        'target': target || 'question',
        'id': id || null,
        'section': section || 'survey/questions',
        'success': success || true,
        'errormessage': errMessage || null,
        'who': this.getCurrentUser().email,
        'created_at': this.getNewDateWTime()
      }
    },
    getSavedExtraInfo (saveData) {
      if (this.isNotNullorUndefined(saveData) && typeof (saveData) === 'object') {
        let extraData = {
          'id': this.getTimestamp(),
          'created_at': this.getNewDateWTime(),
          'created_by': this.getCurrentUser().email
        }
        return extend(saveData, extraData)
      }
    },
    getQuestionListData () {
      return {
        'data': this.$root.surveyQuestions,
        'filterableFields': ['title']
      }
    },
    getData (target) {
      return {
        'data': this.$root[target],
        'filterableFields': ['title']
      }
    },
    deletePointKey (array) {
      let ro = {}
      for (let k of array) {
        let kq = k['.key']
        ro[kq] = k
        delete ro[kq]['.key']
      }
      return ro
    }
  }
})

/* Vue App initialize */
new Vue({
  el: '#app',
  router,
  firebase: {
    users: dbDashboardApp.ref('users').orderByChild('name'),
    log: dbDashboardApp.ref('log').orderByChild('created_at'),
    surveyCampaigns: {
      source: dbDashboardApp.ref('survey/campaigns').orderByChild('created_at'),
      cancelCallback (err) {
        if (this.isNotNullorUndefined(err)) {
          this.launchToast(err.message, 'error')
        }
      }
    },
    surveyQuestions: {
      source: dbDashboardApp.ref('survey/questions').orderByChild('name'),
      cancelCallback (err) {
        if (this.isNotNullorUndefined(err)) {
          this.launchToast(err.message, 'error')
        }
      }
    }
  },
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js